var AuthToken = function ($injector, $q) {

    var Service = function () {
        this.deferred = $q.defer();
        this.pending = false;
        this.token = '';
        this.isResolved = false;
        this.resolvePromise = null;
    };

    Service.prototype.getToken = function () {
        return this.token;
    };

    Service.prototype.setToken = function (value) {
        this.pending = false;
        this.token = value;
        return this.getToken();
    };

    Service.prototype.tokenIsResolved = function (url) {
        return this.isResolved;
    };

    Service.prototype.resolveToken = function (url) {
        if (!this.token && !this.pending) {
            this.pending = true;
            var $http = $injector.get('$http');
            var bootstrapParameters = $injector.get('bootstrapParameters');
            var code = bootstrapParameters.getParameter('code');
            var data = 'grant_type=client_credentials&client_id=urn:oss';
            if (code) {
                data = 'client_id=urn:oss&grant_type=authorization_code&code=' + code;
            }
            $http({
                url: url,
                method: 'POST',
                data: data,
                params: '',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (res) {
                this.deferred.resolve(this.setToken(res.data.access_token));
            }.bind(this)).catch(function (err) {
                // this.deferred.reject(err);
                this.deferred.resolve(this.setToken("blabla")); // TODO remove fake token
            }.bind(this)).finally(function () {
                this.isResolved = true;
            });
            return this.resolvePromise = this.deferred.promise;
        } else {
            return this.resolvePromise = this.deferred.promise;
        }
    };

    Service.prototype.resolveOAuthToken = function (url, data) {
        var $http = $injector.get('$http');
        return $http({
            url: url,
            method: 'POST',
            data: data,
            params: '',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function (res) {
            this.setToken(res.data.access_token);
            return res;
        }.bind(this)).catch(function (err) {
            return $q.reject(err);
        }.bind(this));
    };

    return new Service();
};

AuthToken.$inject = ['$injector', '$q'];

module.exports = AuthToken;
